import TourConfigBreadcrumbs from '@/features/dashboard/tourConfig/components/TourConfigBreadcrumbs.tsx';
import TourConfigHeader from '@/features/dashboard/tourConfig/components/TourConfigHeader.tsx';
import React from 'react';
import TourConsentsConfigCard from '@/features/dashboard/tourConsents/components/TourConsentsConfigCard.tsx';
import { useNavigate } from '@tanstack/react-router';
import { tourConsentsConfigRoute } from '@/features/dashboard/tourConsents/routes/tourConsentsConfigRoute.ts';

const TourConsentsConfigPage = () => {
  const { tourId } = tourConsentsConfigRoute.useParams();
  const navigate = useNavigate();

  const onNext = async () => {
    navigate({ to: `/app/tours/${tourId}/config/insurances` });
  };

  return (
    <div className="space-y-4">
      <TourConfigBreadcrumbs />
      <div className="flex-1 space-y-4"></div>
      <TourConfigHeader title="Zgody" isLoading={false} submit={onNext} />
      <div className="mx-auto max-w-[700px] space-y-2">
        <TourConsentsConfigCard />
      </div>
    </div>
  );
};

export default TourConsentsConfigPage;
